import {
  ADD_PACKAGE_TRANSACTION,
  DELETE_PACKAGE_TRANSACTION,
  GET_ALL_PACKAGE_TRANSACTION,
  UPDATE_PACKAGE_TRANSACTION,
  UPDATE_PACKAGE_TRANSACTION_STATUS,
} from "../types";

const initialState = { list: [], single: null };

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    // ===============================
    // 👉 GET ALL PACKAGE TRANSACTIONS
    // ===============================
    case GET_ALL_PACKAGE_TRANSACTION:
      return { ...state, list: payload };

    // ===============================
    // 👉 UPDATE PACKAGE TRANSACTION
    // ===============================
    case UPDATE_PACKAGE_TRANSACTION:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item
        ),
      };

    // ===============================
    // 👉 UPDATE PACKAGE TRANSACTION STATUS
    // ===============================
    case UPDATE_PACKAGE_TRANSACTION_STATUS:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item
        ),
      };

    // ===============================
    // 👉 ADD PACKAGE TRANSACTION
    // ===============================
    case ADD_PACKAGE_TRANSACTION:
      return {
        ...state,
        list: [payload, ...state.list],
      };

    // ===============================
    // 👉 DELETE PACKAGE TRANSACTION
    // ===============================
    case DELETE_PACKAGE_TRANSACTION:
      return {
        ...state,
        list: state.list.filter((item) => item.id !== payload.id),
      };

    default:
      return state;
  }
};

export default reducer;
